var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.operate] || "-",
          backUrl: "/marketing/lottery-assistant/reply",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户名称：", prop: "userName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入用户名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.userName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "userName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.userName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户头像：", prop: "userAvatar" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("avatar")
                                },
                              },
                            },
                            [
                              _vm.formValidate.userAvatar
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.formValidate.userAvatar,
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：100*100px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "评论内容：", prop: "replyMsg" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入评论内容",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.replyMsg,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "replyMsg",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.replyMsg",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "评论图片：", prop: "replyPic" } },
                        [
                          _c(
                            "div",
                            { staticClass: "upLoadPicBox acea-row" },
                            [
                              _vm._l(_vm.picList, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "pictrue" },
                                  [
                                    _c("img", { attrs: { src: item } }),
                                    !_vm.isDisabled
                                      ? _c("i", {
                                          staticClass: "el-icon-delete btndel",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRemovePic(index)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              _vm.picList.length < 10
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isDisabled,
                                          expression: "!isDisabled",
                                        },
                                      ],
                                      staticClass: "upLoad",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap("pic")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-camera cameraIconfont",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [
                              _vm._v(
                                "建议尺寸：702*352px，上传小于1mb的图片，最多上传10张"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否启用：", prop: "isEnabled" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": true,
                              "inactive-value": false,
                              "active-text": "是",
                              "inactive-text": "否",
                            },
                            model: {
                              value: _vm.formValidate.isEnabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "isEnabled", $$v)
                              },
                              expression: "formValidate.isEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi(["platform:draw:reply:save"])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }